export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const API_KEY = 'b41a9a43-f37a-446b-88cc-6f35ddedbe9a';
export const TIMEOUT_SECONDS = 10;
export const RESULTS_PER_PAGE = 10;
export const MODAL_CLOSE_SECONDS = 2.5;
